import "./styles.scoped.css";
export default {
    "root": "awsui_root_vrgzu_1obpu_93",
    "recovery": "awsui_recovery_vrgzu_1obpu_105"
};
